import { gql } from '@apollo/client';

export const DELETE_PAYMENT_METHOD = gql`
  mutation deletePaymentMethod($paymentMethodId: String!) {
    deletePaymentMethod(paymentMethodId: $paymentMethodId)
  }
`;
